import { Component, ElementRef, OnInit, AfterViewInit, ChangeDetectorRef, ViewChild} from '@angular/core';
import {CategoryModel} from '../../product-category/models/category.model';
import {ProductCategoryService} from '../../product-category/services/product-category.service';
import {ProductModel} from '../../product-category/models/product.model';
import {ResourceModel} from '../../product-category/models/resource.model';
import {environment} from '../../../environments/environment';
import { Subject } from 'rxjs/Subject';
import { DxSelectBoxComponent } from 'devextreme-angular';
@Component({
  selector: 'app-resources',
  templateUrl: 'resources-container.component.html',
  styleUrls: ['resources-container.component.scss']
})

export class ResourcesContainerComponent implements OnInit, AfterViewInit {

  hierarchy: CategoryModel[] = [];
  hierarchyEvent: Subject<CategoryModel[]> = new Subject<CategoryModel[]>();

  getResourcesEvent: Subject<boolean> = new Subject<boolean>();

  selectedCategory: string = "All Categories";
  categories: string[] = [];
  selectedCategoryEvent: Subject<string> = new Subject<string>();

  selectedResourceType: string = "All Resource Types";
  resourceTypes: string[] = [];
  selectedResourceTypeEvent: Subject<string> = new Subject<string>();
  hideFilteredResourcesEvent: Subject<boolean> = new Subject<boolean>();
  productCategorySelected: Subject<string> = new Subject<string>();
  selectedProductIdEvent: Subject<string> = new Subject<string>();

  productClass: CategoryModel[] = [];
  productTypes: ProductModel[] = [];
  productTypeCats: CategoryModel[] = [];
  filteredResources: ResourceModel[];
  isCommercial = false;
  selectedProductId: string;
  selectedHierarchyId: string = null;
  selectedHierarchyFilter: string = null;
  selectedClassId: string = null;
  displayDownloadLink: boolean = false;
  productClassVisible = false;
  selectedClassOptionId: string = null;
  productTypePlaceholder: string = "Choose Product Category First";
  archiveUrl: string = null;
  archiveUrlEvent: Subject<string> = new Subject<string>();
  displayDownloadEvent: Subject<boolean> = new Subject<boolean>();
  showallresources = 'true';
  rolepermission: string;

  @ViewChild('productClassSelect') productClassSelect: DxSelectBoxComponent;
  @ViewChild('productTypeSelect') productTypeSelect: DxSelectBoxComponent;

  constructor(private service: ProductCategoryService, private hostElement: ElementRef, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    const showAtt = this.hostElement.nativeElement.getAttributeNode('showall');
    this.showallresources = showAtt && showAtt.value ? showAtt.value : 'false';
    const roleAtt = this.hostElement.nativeElement.getAttributeNode('roleperm');
    this.rolepermission = roleAtt && roleAtt.value ? roleAtt.value : '';
    if(this.showallresources == 'true') {
      this.setProductClasses();
      this.setProductTypePlaceholder();
    }
  }

  ngAfterViewInit() {
    this.setProductHierarchies();
  }

  async hierarchySelected(catId: string) {
    // mark category as selected and load products
    this.resetFilters();
    this.selectHierarchy(catId);
    switch(catId) {
      case 'Multi V Outdoor':
        this.productTypes = await this.getProductsForCategory('Outdoor Units', 'Multi V');
        this.selectedHierarchyFilter = 'Outdoor Units';
        this.selectedClassId = 'Multi V';
        break;
      case 'Multi V Indoor':
        this.productTypes = await this.getProductsForCategory('Indoor Units', 'Multi V');
        this.selectedHierarchyFilter = 'Indoor Units';
        this.selectedClassId = 'Multi V';
        break;

      case 'Multi Zone Indoor':
        this.productTypes = await this.getProductsForCategory('Indoor Units', 'Multi Zone');
        this.selectedHierarchyFilter = 'Indoor Units';
        this.selectedClassId = 'Multi Zone';
        break;
      case 'Multi Zone Outdoor':
        this.productTypes = await this.getProductsForCategory('Outdoor Units', 'Multi Zone');
        this.selectedHierarchyFilter = 'Outdoor Units';
        this.selectedClassId = 'Multi Zone';
        break;
      case 'Single Zone':
        this.productTypes = await this.getProductsForCategory('Indoor Units', 'Single Zone');
        this.selectedHierarchyFilter = 'Indoor Units';
        this.selectedClassId = 'Single Zone';
        break;
      case 'PTAC':
        this.productTypes = await this.getProductsForCategory('PTAC', 'PTAC');
        this.selectedHierarchyFilter = 'PTAC';
        this.selectedClassId = 'PTAC';
        break;
      case 'Chillers':
        this.selectedHierarchyFilter = catId;
         this.productTypes = await this.getProductsForCategory(catId);
         this.selectedClassId = '';
         break;        
      case 'Controls':
      case 'Accessories':
      case 'Water Heating':
      case 'Air Technologies':
        this.selectedHierarchyFilter = catId;
        this.productTypes = [];
        if (this.productClassSelect) {
          for (const product of this.productClass) {
            product.selected = false;
          }
          this.productClassSelect.instance.reset();
        }
        this.productTypes = await this.getProductsForCategory(catId);
        this.productClassVisible = true;
        this.cdr.detectChanges();
        this.selectedClassId = '';
        break;
    }
    this.setProductCats();
    this.setArchiveUrl();
  }

  selectHierarchy(catId: string) {
    for (let hierarchy of this.hierarchy) {
      hierarchy.selected = catId === hierarchy.id;
      if (hierarchy.selected) {
        this.hideFilteredResourcesEvent.next(true);
      }
    }

    this.selectedHierarchyId = catId;
    this.productCategorySelected.next(this.selectedHierarchyId);
    this.setProductTypePlaceholder();
    this.resetFilterDropdowns();
    this.productTypes = [];
    this.productTypeCats = [];
    this.hierarchyEvent.next(this.hierarchy);
  }

  setProductTypePlaceholder() {
    this.productTypePlaceholder = this.selectedHierarchyId ? "Product Type" : "Choose Product Category First"
    this.productTypeSelect.placeholder = this.productTypePlaceholder;
  }

  selectResourceType(data) {
    this.selectedResourceType = typeof data === "string" ? data : data.value;
    this.selectedResourceTypeEvent.next(this.selectedResourceType);
  }

  selectCategory(data) {
    this.selectedCategory = typeof data === "string" ? data : data.value;
    this.selectedCategoryEvent.next(this.selectedCategory);
  }

  async classSelected(data) {
    // mark category as selected and load product
    this.resetFilterDropdowns();
    this.productTypeSelected(null);
    const classId = data.value;
    this.selectedClassId = classId;
    for (const productClass of this.productClass) {
      productClass.selected = productClass.id === classId;
    }
    this.productTypes = await this.getProductsForCategory(this.selectedHierarchyId, classId);
    this.setProductCats();
    this.setArchiveUrl();
  }

  private setProductCats() {
    const tempCats: CategoryModel[] = [];
    for (const prod of this.productTypes) {
      const cat: CategoryModel = {
        id: prod.id,
        name: prod.title,
        selected: false
      };
      tempCats.push(cat);
    }
    this.productTypeCats = tempCats.sort((a, b) => {
      return a > b ? 1 : -1;
    });
    this.setArchiveUrl();
  }

  async productTypeSelected(selected: any) {
    this.selectedProductId = (typeof selected === "string" || selected === null) ? selected : selected.value;
    this.selectedProductId ? this.hideFilteredResourcesEvent.next(false) : this.hideFilteredResourcesEvent.next(true);
    this.selectedProductIdEvent.next(this.selectedProductId);
    this.resetFilterDropdowns();
    this.setArchiveUrl();
  }

  setArchiveUrl() {
    this.archiveUrl = this.selectedProductId ?
      `${environment.archivePath}/resource_archive_${this.selectedProductId}_${this.selectedHierarchyFilter}_${this.selectedClassId ? this.selectedClassId : ''}.zip`
      : null;
    console.log(this.archiveUrl);
  }

  filterResourceTypesDropdown(data: string[]) {
    this.resourceTypes = data;
  }

  filterCategoriesDropdown(data: string[]) {
    this.categories = data;
  }

  resetFilterDropdowns() {
    this.selectResourceType("All Resource Types");
    this.selectCategory("All Categories");
  }

  resetFilters() {
    this.productTypes = [];
    this.selectedProductId = null;
    this.productClassVisible = false;
    this.archiveUrl = null;
    this.filteredResources = [];
    this.displayDownloadLink = false;
  }

  setProductHierarchies() {
    this.hierarchy = [
      { id: 'Multi V Indoor',       name: 'Multi V Indoor',     line: 'Commercial', selected: false },
      { id: 'Multi V Outdoor',      name: 'Multi V Outdoor',    line: 'Commercial', selected: false },
      { id: 'Chillers',             name: 'Chillers',           line: 'Commercial', selected: false },
      { id: 'Multi Zone Indoor',    name: 'Multi Zone Indoor',  line: 'Residential%2FLight%20Commercial', selected: false },
      { id: 'Multi Zone Outdoor',   name: 'Multi Zone Outdoor', line: 'Residential%2FLight%20Commercial', selected: false },
      { id: 'Single Zone',          name: 'Single Zone',        line: 'Residential%2FLight%20Commercial', selected: false },
      { id: 'Controls',             name: 'Controls',           line: 'Residential%2FLight%20Commercial', selected: false },
      { id: 'Accessories',          name: 'Accessories',        line: 'Residential%2FLight%20Commercial', selected: false },
      { id: 'Water Heating',        name: 'Water Heating',      line: 'Residential%2FLight%20Commercial', selected: false },
      { id: 'Air Technologies',     name: 'Air Technologies',   line: 'Residential%2FLight%20Commercial', selected: false },
      { id: 'PTAC',                 name: 'PTAC',               line: 'Residential%2FLight%20Commercial', selected: false }
    ];
    this.hierarchyEvent.next(this.hierarchy);
  }

  setProductClasses() {
    this.productClass = [
      { id: 'Single Zone', name: 'Single Zone', selected: false },
      { id: 'Multi Zone', name: 'Multi Zone', selected: false },
      { id: 'Multi V', name: 'Multi V', selected: false },
      { id: 'PTAC', name: 'PTAC', selected: false }
    ];
  }

  async getProductsForCategory(catId?: string, addClass?: string): Promise<ProductModel[]> {
    let result: ProductModel[] = [];
    await this.service.getProductsByCategory(catId, addClass)
      .then(
        res => {
          if (res) {
            let productArray: any[];
            productArray = res as any[];
            result =  productArray ? productArray.map(item => new ProductModel(item)) : [];
            return result.sort((a: ProductModel, b: ProductModel) => {
              return a.title > b.title ? -1 : 1;
            });
          }
        }
      ).catch(err => console.log(err));
    return result;
  }

  setFilteredResources(data: ResourceModel[]) {
    this.filteredResources = data;
    if (this.filteredResources.length > 0 && this.archiveUrl) {
      this.displayDownloadLink = true;
      this.archiveUrlEvent.next(this.archiveUrl);
    } else {
      this.displayDownloadLink = false;
    }
    this.displayDownloadEvent.next(this.displayDownloadLink);
  }

  hideFilteredResources(result: boolean) {
    this.hideFilteredResourcesEvent.next(result);
  }

  resetAllFilters() {
    for (const productClass of this.productClass) {
      productClass.selected = false;
    }

    this.selectedHierarchyId = null;
    this.productTypeCats = [];
    this.productCategorySelected.next(this.selectedHierarchyId);
    this.selectedProductId = null;
    this.selectedProductIdEvent.next(this.selectedProductId);
    this.selectedClassOptionId = null;
    this.productClassVisible = false;

    this.resetFilterDropdowns();
    this.setProductTypePlaceholder();

    for (let hierarchy of this.hierarchy) {
      hierarchy.selected = false;
    }
    this.hierarchyEvent.next(this.hierarchy);
    this.getResourcesEvent.next(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/containers/resources-container.component.ts